module.exports = __webpack_public_path__ + "img/marathon_logo_en.660be953.svg";